import { Navigate, useParams } from 'react-router-dom';
import { AgnesPageHeader } from '@agnes/ui';
import { getIncidenciaSpec } from '@/lib/incidenciaSpecs';
import PageTabelaIncidencia from './PageTabelaIncidencia';
import { Table2 } from 'lucide-react';

// aceita tanto o slug do hub (fgts_incidence) quanto a key curta (fgts)
const NORM: Record<string, string> = {
  fgts_incidence: 'fgts',
  cprp_incidence: 'cprp',
  inss_incidence: 'inss',
  irrf_incidence: 'irrf',
  pispasep_incidence: 'pispasep',
  rubric_nature: 'natureza',
  rubric_type: 'tipo',
};

export default function PageTabelaDetalhe() {
  const { tabela } = useParams<{ tabela: string }>();
  const key = (tabela && NORM[tabela]) || tabela;
  const spec = getIncidenciaSpec(key);

  if (spec) return <PageTabelaIncidencia spec={spec} />;
  // CON-4866: o olho da Tabela de CBO abre a listagem de ocupações CBO (não o dashboard do trabalhador).
  if (tabela === 'cbo_occupations') return <Navigate to="/esocial/cbo/ocupacoes" replace />;

  return (
    <>
      <AgnesPageHeader
        icon={<Table2 />}
        title="Em breve"
        subtitle="Esta tabela será disponibilizada em uma próxima entrega."
        breadcrumbs={[
          { label: 'Home', href: '/home' },
          { label: 'Configurações' },
          { label: 'Tabelas', href: '/admin/tabelas' },
          { label: 'Detalhe' },
        ]}
      />
    </>
  );
}
